import React, { useState } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";

import logoText from "../assets/images/new_logo.png";
import logoText1 from "../assets/images/yente ai og.png";
import logoIcon from "../assets/images/logo.png";

// --- FUTURISTIC BACKGROUND ---
function FuturisticBackground() {
  const { scrollY } = useScroll();
  const yGrid = useTransform(scrollY, [0, 1000], [0, -150]);
  const rotateGrid = useTransform(scrollY, [0, 1000], [0, 5]);
  const yOrb2 = useTransform(scrollY, [0, 1000], [0, -200]);
  const rotateRing = useTransform(scrollY, [0, 2000], [0, 360]);
  const smoothRotate = useSpring(rotateRing, { stiffness: 50, damping: 20 });

  return (
    <div className="fixed inset-0 overflow-hidden -z-10 bg-[#003049]">
      <div className="absolute inset-0 bg-gradient-to-br from-[#001824] via-[#003049] to-[#004e75]" />

      <motion.div
        style={{ y: yGrid, rotateX: rotateGrid }}
        className="absolute inset-[-50%] w-[200%] h-[200%] origin-top 
        bg-[linear-gradient(to_right,#457B9D22_1px,transparent_1px),
        linear-gradient(to_bottom,#457B9D22_1px,transparent_1px)]
        bg-[size:4rem_4rem]"
      />

      <motion.div
        style={{ y: yOrb2 }}
        className="absolute bottom-[10%] right-[5%] w-[40vw] h-[40vw] 
        bg-[#457B9D] rounded-full blur-[140px] opacity-30 mix-blend-screen"
      />

      <motion.div
        style={{ rotate: smoothRotate }}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 
        w-[800px] h-[800px] border border-[#D1D1D1]/10 rounded-full border-dashed"
      />
    </div>
  );
}

function ContactUsPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ✔ Email submit (Nodemailer backend)
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("http://localhost:5000/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await response.json();

      if (data.success) {
        alert("Your enquiry has been sent!");
        setForm({ name: "", email: "", message: "" });
      } else {
        alert("Failed to send email. Please try again.");
      }
    } catch (error) {
      console.error(error);
      alert("Error sending email.");
    }
  };

  return (
    <div className="font-sans min-h-screen pt-24 px-4 pb-12 text-gray-200 relative overflow-hidden">
      <FuturisticBackground />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative z-10 max-w-3xl mx-auto"
      >
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-8 text-white">
          Contact <span className="text-[#D1D1D1]">Us</span>
        </h1>

        {/* CONTACT FORM */}
        <motion.form
          onSubmit={handleSubmit}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="bg-[#002639]/80 backdrop-blur-md border border-[#457B9D] shadow-2xl rounded-xl p-8 space-y-6"
        >
          {/* Name */}
          <div>
            <label className="block text-[#D1D1D1] font-medium mb-2">Name</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              className="w-full bg-[#003049] border border-[#457B9D] rounded-lg px-4 py-3 text-white"
              placeholder="Your Name"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-[#D1D1D1] font-medium mb-2">Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              className="w-full bg-[#003049] border border-[#457B9D] rounded-lg px-4 py-3 text-white"
              placeholder="you@example.com"
            />
          </div>

          {/* Message */}
          <div>
            <label className="block text-[#D1D1D1] font-medium mb-2">Message</label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              required
              rows={4}
              className="w-full bg-[#003049] border border-[#457B9D] rounded-lg px-4 py-3 text-white"
              placeholder="Write your message..."
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-lg shadow-md"
          >
            Send Enquiry
          </button>
        </motion.form>

        {/* Social Links */}
        <div className="flex justify-center gap-6 mt-12">
          {[
            // { href: "https://facebook.com/", icon: "https://img.icons8.com/color/48/facebook-new.png", alt: "Facebook" },
            // { href: "https://twitter.com/", icon: "https://img.icons8.com/color/48/twitter--v1.png", alt: "Twitter" },
            { href: "https://www.instagram.com/ente.ai/", icon: "https://img.icons8.com/color/48/instagram-new.png", alt: "Instagram" },
            { href: "https://in.linkedin.com/company/ente-ai", icon: "https://img.icons8.com/color/48/linkedin.png", alt: "LinkedIn" },
          ].map((social, idx) => (
            <a
              key={idx}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full p-3 transition-transform hover:scale-110 hover:bg-[#002639] border border-transparent hover:border-[#D1D1D1]"
              aria-label={social.alt}
            >
              <img src={social.icon} alt={social.alt} className="w-10 h-10" />
            </a>
          ))}
        </div>  

        {/* Location Info Card */}
        <div className="mt-12 flex flex-col md:flex-row gap-8 items-stretch">
          {/* Left: Address, Logo, WhatsApp */}
          <div className="flex-1 bg-[#002639]/80 backdrop-blur-md border border-[#457B9D] shadow-xl rounded-xl p-6 flex flex-col justify-between group hover:border-[#D1D1D1] transition-all duration-300">
            <div className="flex items-center gap-2 mt-4">
              <div className="font-bold flex items-center justify-center p-5 mt-4">
                <img 
                  src={logoIcon} 
                  alt="whitelogo" 
                  style={{ width: "70px", height: "70px" }} 
                  className="object-contain -mt-5" 
                />
              </div>
              <div>
              <div className="font-bold flex items-center justify-center mb-4">
                <img 
                  src={logoText1} 
                  alt="logo_text" 
                  style={{ height: "70px", width: "auto" }} 
                  className="object-contain"
                />
              </div>
                <div className="text-gray-300 text-sm leading-relaxed">
                  <p>OP Building</p>
                  <p>Pookkayil, Tirur</p>
                  <p>Malappuram, Kerala</p>
                  <p>676107</p>
                  <p className="mt-2 font-semibold text-[#D1D1D1]">+91 88482 95437</p>
                </div>
              </div>
            </div> 
          </div>
          
          {/* Right: Google Map */}
          <div className="flex-1 rounded-xl overflow-hidden shadow-xl border border-[#457B9D]">
            <iframe
              title="Google Map Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3917.5032355722087!2d75.91026897504402!3d10.925307589232652!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7b3f2220fd9d3%3A0x941ef169a0ba2a91!2sENTE%20AI!5e0!3m2!1sen!2sin!4v1756606803748!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '250px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="grayscale hover:grayscale-0 transition-all duration-500"
            ></iframe>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default ContactUsPage;
